import { encodeBase64 } from "../utils/base64";
import { Dispatcher } from "../utils/events/dispatcher";
import { DataApiResponse } from "./data_api_response";
import { DataCacheObject } from "./data_cache_object";
import { DataProvider, DataProviderQueryResult, NON_EXISTING } from "./data_provider";

export class ClientDataProvider implements DataProvider {
  private cache = new Map<string, DataProviderQueryResult>();

  constructor(initialCache: DataCacheObject | undefined) {
    if (initialCache) {
      for (const key in initialCache) {
        const dispatcher = new Dispatcher();
        const onUpdate = dispatcher.cachingSignal();
        dispatcher.emit(onUpdate, initialCache[key]);
        const result = {
          onUpdate,
        };
        this.cache.set(key, result);
      }
    }
  }

  get(ids: string[]): DataProviderQueryResult {
    const cacheKey = ids.join(".");
    if (this.cache.has(cacheKey)) {
      return this.cache.get(cacheKey)!;
    }

    const dispatcher = new Dispatcher();
    const onUpdate = dispatcher.cachingSignal();
    this.fetchValue(ids).then((value) => {
      dispatcher.emit(onUpdate, value);
    });

    const result = {
      onUpdate,
    };

    this.cache.set(cacheKey, result);

    return result;
  }

  private async fetchValue(ids: string[]): Promise<unknown | typeof NON_EXISTING> {
    const query = new URLSearchParams({
      ids: encodeBase64(ids.join(".")),
    });
    const req = new Request(`/_/data?${query}`, {
      method: "GET",
    });

    const resp = await fetch(req);
    const json = (await resp.json()) as DataApiResponse;

    if (!json.exists) {
      return NON_EXISTING;
    }

    return json.value;
  }
}
